import nearService from "../services/near.service.js";

export default {
    install(Vue) {
        Vue.prototype.$near = nearService(Vue);
    }
}